import React, { useEffect, useState } from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';
import DynamicPracticePage from '../../components/common/DynamicPracticePage';
import { TopicItem } from '../../components/common/PracticeContentLayout';
import { ContentPage } from '../../types/content';
import { loadHLDFundamentalsContent } from '../../data/hld/hldFundamentalsContent';

const topics: TopicItem[] = [{
  id: 'hld-fundamentals',
  title: 'HLD Fundamentals',
  children: [
    { id: 'scale-from-zero-to-millions', title: '01 · Scale from zero to millions' },
    { id: 'back-of-the-envelope-estimation', title: '02 · Back-of-the-envelope estimation' },
    { id: 'system-design-interview-framework', title: '03 · A framework for system design interviews' },
  ],
}];

const HLDFundamentalsArticle: React.FC = () => {
  const [contentPages, setContentPages] = useState<Record<string, ContentPage> | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    loadHLDFundamentalsContent()
      .then(setContentPages)
      .catch(() => setError('The HLD chapter content could not be loaded. Please refresh the page.'));
  }, []);

  if (error) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6 text-center">
        <div>
          <AlertCircle className="w-10 h-10 mx-auto mb-3 text-red-500" />
          <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100">Content unavailable</h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">{error}</p>
        </div>
      </div>
    );
  }

  if (!contentPages) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-primary-600 dark:text-primary-400 mx-auto mb-3" />
          <p className="text-gray-600 dark:text-gray-400">Loading HLD fundamentals...</p>
        </div>
      </div>
    );
  }

  return (
    <DynamicPracticePage
      topicType="hld"
      title="HLD Fundamentals"
      topics={topics}
      basePath="/practice/hld/fundamentals"
      getSlugForTopic={(topicId) => 'hld-' + topicId}
      staticContentPages={contentPages}
      articleClassName="system-design-article-page"
    />
  );
};

export default HLDFundamentalsArticle;
